export default __webpack_public_path__ + "static/media/norte2020.0e4e220f.png";